;(function() {
  'use strict'

  angular.module('core.element-search', [])
})()
